// extracted by mini-css-extract-plugin
export default {"list":"best-stories-content_list__xBGiB","bc-no-stories-info":"best-stories-content_bc-no-stories-info__9msuA"};